import * as types from './types';

const initialState = {
  // PublisherData State
  data: null,
  loadingData: false,
  fetchedData: false,
  // Config State
  config: null,
  loadingConfig: false,
  fetchedConfig: false,
  fetchErrorConfig: false,
  successConfig: false,
  errorConfig: false,
  // Branch State
  branches: null,
  loadingBranches: false,
  fetchedBranches: false,
  fetchErrorBranches: false,
  successBranches: false,
  successEnabled: false,
  errorBranches: false,
  // Agent State
  agent: null,
  loadingAgent: false,
  fetchedAgent: false,
  fetchErrorAgent: false,
  // Autologin State
  autologin: null,
  loadingAutologin: false,
  fetchedAutologin: false,
  fetchErrorAutologin: false,
  autologinFetchOneTimeOnly: false,
  // Users State
  users: null,
  loadingUsers: false,
  fetchedUsers: false,
  fetchErrorUsers: false,
  // Change Password User
  userPassword: null,
  loadingUserPassword: false,
  errorUserPassword: false,
  // Common State
  sentData: null,
  path: null,
  generalDispatch: false,
  modal: null,
  owner: null,
  // Share commission get
  loadingSharedCommission: false,
  fetchedSharedCommission: false,
  errorSharedCommission: false,
  sharedCommission: null,
  // share commission save
  settingCommissionShare: false,
  commissionShareCompleted: false,
  errorSettingCommissionShare: false,
  // share commission delete
  deletingCommissionShare: false,
  commissionShareDeleteCompleted: false,
  errorDeletingCommissionShare: false
};

function configurationPubrReducer(state = initialState, action) {
  switch (action.type) {
    // Getting company data
    case types.GET_COMPANY_DATA:
      return {
        ...state,
        loadingData: true,
        data: null,
        fetchedData: false,
        path: action.meta.section
      };

    case types.GET_COMPANY_DATA_COMPLETED:
      return {
        ...state,
        loadingData: false,
        fetchedData: true,
        data: action.payload,
        agent: action.payload.ownerId
          ? {
              ownerId: action.payload.ownerId,
              ownerName: action.payload.ownerName,
              ownerEmail: action.payload.ownerEmail,
              ownerPhone: action.payload.ownerPhone
            }
          : null,
        fetchedAgent: true
      };

    case types.GET_COMPANY_DATA_FAILED:
      return {
        ...state,
        loadingData: false,
        fetchedData: true
      };

    // Getting company configuration options
    case types.GET_COMPANY_CONFIG:
      return {
        ...state,
        loadingConfig: true,
        config: null,
        fetchedConfig: false,
        fetchErrorConfig: false,
        successConfig: false,
        path: action.meta.section
      };

    case types.GET_COMPANY_CONFIG_COMPLETED:
      return {
        ...state,
        loadingConfig: false,
        fetchedConfig: true,
        config: action.payload
      };

    case types.GET_COMPANY_CONFIG_FAILED:
      return {
        ...state,
        loadingConfig: false,
        fetchedConfig: true,
        fetchErrorConfig: true
      };

    // Changing company configuration option
    case types.PUT_COMPANY_PUBR:
      return {
        ...state,
        loadingConfig: true,
        successConfig: false,
        savingPubrError: false,
        errorConfig: null,
        sentData: action.meta,
        path: action.meta.section
      };

    case types.PUT_COMPANY_PUBR_COMPLETED:
      return {
        ...state,
        loadingConfig: false,
        successConfig: true
      };

    case types.PUT_COMPANY_PUBR_FAILED:
      return {
        ...state,
        loadingConfig: false,
        savingPubrError: true,
        errorConfig: action.payload.data.message
      };

    // Getting users
    case types.GET_COMPANY_USERS:
      return {
        ...state,
        loadingUsers: true,
        fetchedUsers: false,
        users: null,
        fetchErrorUsers: false,
        errorUsers: false,
        path: action.meta.section
      };

    case types.GET_COMPANY_USERS_COMPLETED:
      return {
        ...state,
        loadingUsers: false,
        fetchedUsers: true,
        users: action.payload
      };

    case types.GET_COMPANY_USERS_FAILED:
      return {
        ...state,
        loadingUsers: false,
        fetchErrorUsers: true,
        errorUsers: action.payload.data.message
      };

    // Change password user
    case types.PASSWORD_COMPANY_USERS:
      return {
        ...state,
        loadingUserPassword: true,
        userPassword: null,
        errorUserPassword: false
      };

    case types.PASSWORD_COMPANY_USERS_COMPLETED:
      return {
        ...state,
        loadingUserPassword: false,
        userPassword: action.payload || true
      };

    case types.PASSWORD_COMPANY_USERS_FAILED:
      return {
        ...state,
        loadingUserPassword: false,
        errorUserPassword: action.payload.data.message
      };

    // Getting autologin in unfied panel
    case types.GET_AUTOLOGIN:
      return {
        ...state,
        loadingAutologin: true,
        autologinFetchOneTimeOnly: true,
        autologinError: null,
        sentData: action.meta,
        path: action.meta.section,
        generalDispatch: action.meta.general,
        modal: action.meta.modal
      };

    case types.GET_AUTOLOGIN_COMPLETED:
      return {
        ...state,
        loadingAutologin: false,
        autologin: action.payload.portalAutologinLink,
        fetchedAutologin: true
      };

    case types.GET_AUTOLOGIN_FAILED:
      return {
        ...state,
        loadingAutologin: false,
        fetchErrorAutologin: true
      };

    // Getting company agent data
    case types.GET_AGENT_DATA:
      return {
        ...state,
        loadingAgent: true,
        fetchErrorAgent: false,
        sentData: action.meta,
        fetchedAgent: true,
        path: action.meta.section,
        generalDispatch: action.meta.general,
        modal: action.meta.modal,
        owner: action.meta.owner
      };

    case types.GET_AGENT_DATA_COMPLETED:
      return {
        ...state,
        loadingAgent: false,
        agent: action.payload.ownerId
          ? {
              ownerId: action.payload.ownerId,
              ownerName: action.payload.ownerName,
              ownerEmail: action.payload.ownerEmail,
              ownerPhone: action.payload.ownerPhone
            }
          : null,
        data: action.payload,
        fetchedAgent: true
      };

    case types.GET_AGENT_DATA_FAILED:
      return {
        ...state,
        loadingAgent: false,
        fetchErrorAgent: true
      };

    case types.GET_BRANCHES:
      return {
        ...state,
        branches: null,
        loadingBranches: true,
        successBranches: false,
        errorBranches: null,
        fetchedBranches: false,
        sentData: action.meta,
        path: action.meta.section
      };

    case types.GET_BRANCHES_COMPLETED:
      return {
        ...state,
        loadingBranches: false,
        fetchedBranches: true,
        branches: action.payload
      };

    case types.GET_BRANCHES_FAILED:
      return {
        ...state,
        loadingBranches: false,
        fetchedBranches: true,
        fetchErrorBranches: action.payload.data.message
      };

    case types.POST_BRANCHES_DEACTIVATE:
      return {
        ...state,
        loadingBranches: true,
        successBranches: false,
        errorBranches: false,
        sentData: action.meta,
        path: action.meta.section
      };

    case types.POST_BRANCHES_DEACTIVATE_COMPLETED:
      return {
        ...state,
        loadingBranches: false,
        successBranches: true
      };

    case types.POST_BRANCHES_DEACTIVATE_FAILED:
      return {
        ...state,
        loadingBranches: false,
        errorBranches: true
      };

    case types.PUT_BRANCHES_ACTIVATE:
      return {
        ...state,
        loadingBranches: true,
        successBranches: false,
        errorBranches: false,
        sentData: action.meta,
        path: action.meta.section
      };

    case types.PUT_BRANCHES_ACTIVATE_COMPLETED:
      return {
        ...state,
        loadingBranches: false,
        successEnabled: true
      };

    case types.PUT_BRANCHES_ACTIVATE_FAILED:
      return {
        ...state,
        loadingBranches: false,
        errorBranches: true
      };

    // Reset utility
    case types.RESET_COMPANY_PUBR:
      return {
        ...state,
        // PublisherData State
        data: null,
        loadingData: false,
        fetchedData: false,
        // Config State
        config: null,
        loadingConfig: false,
        fetchedConfig: false,
        fetchErrorConfig: false,
        successConfig: false,
        errorConfig: false,
        // Branch State
        branches: null,
        loadingBranches: false,
        fetchedBranches: false,
        fetchErrorBranches: false,
        successBranches: false,
        successEnabled: false,
        errorBranches: false,
        // Agent State
        agent: null,
        loadingAgent: false,
        fetchedAgent: false,
        successAgent: false,
        fetchErrorAgent: false,
        // Autologin State
        autologin: null,
        loadingAutologin: false,
        fetchedAutologin: false,
        fetchErrorAutologin: false,
        // Users State
        users: null,
        loadingUsers: false,
        fetchedUsers: false,
        fetchErrorUsers: false,
        // Common State
        loading: false,
        fetched: false,
        success: false,
        fetchPubrError: false,
        savingPubrError: false,
        errors: null,
        sentData: null,
        path: null,
        generalDispatch: false,
        modal: null
      };

    case types.RESET_DEACTIVATE:
      return {
        ...state,
        successBranches: false,
        successEnabled: false,
        errorBranches: false,
        sentData: null
      };

    case types.RESET_USER_PASSWORD:
      return {
        ...state,
        userPassword: null,
        errorUserPassword: false
      };

    case types.GET_COMMISSION_SHARE:
      return {
        ...state,
        loadingSharedCommission: true,
        errorSharedCommission: false
      };

    case types.GET_COMMISSION_SHARE_COMPLETED:
      return {
        ...state,
        sharedCommission: action.payload?.percentage?.toString() || null,
        loadingSharedCommission: false,
        fetchedSharedCommission: true
      };

    case types.GET_COMMISSION_SHARE_FAILED:
      return {
        ...state,
        loadingSharedCommission: false,
        fetchedSharedCommission: true,
        errorSharedCommission: true
      };

    case types.SET_COMMISSION_SHARE:
      return {
        ...state,
        settingCommissionShare: true,
        errorSettingCommissionShare: false
      };

    case types.SET_COMMISSION_SHARE_COMPLETED:
      return {
        ...state,
        sharedCommission: action.meta.percentage,
        settingCommissionShare: false,
        commissionShareCompleted: true
      };

    case types.SET_COMMISSION_SHARE_FAILED:
      return {
        ...state,
        settingCommissionShare: false,
        errorSettingCommissionShare: true
      };

    case types.DELETE_COMMISSION_SHARE:
      return {
        ...state,
        deletingCommissionShare: true,
        errorDeletingCommissionShare: false
      };

    case types.DELETE_COMMISSION_SHARE_COMPLETED:
      return {
        ...state,
        sharedCommission: null,
        deletingCommissionShare: false,
        commissionShareDeleteCompleted: true
      };

    case types.DELETE_COMMISSION_SHARE_FAILED:
      return {
        ...state,
        deletingCommissionShare: false,
        errorDeletingCommissionShare: true
      };
    default:
      return state;
  }
}

export default configurationPubrReducer;
